import { useCallback } from 'react';

import { useModal } from '@providers/ModalProvider';

export const useDownloadAppModal = () => {
  const { showDownloadAppModal } = useModal();

  const openDownloadAppModal = useCallback(
    (onConfirm?: () => void) => {
      showDownloadAppModal(onConfirm);
    },
    [showDownloadAppModal],
  );

  return {
    openDownloadAppModal,
  };
};
